import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { Order } from 'depoto-core/src/entities'

@Component({
  selector: 'app-order-expedition',
  templateUrl: './order-expedition.component.html',
  styleUrls: ['./order-expedition.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderExpeditionComponent {
  @Input() order: Order
  @Input() canCreateOrEdit = false
  @Output() orderChange: EventEmitter<any> = new EventEmitter<any>()
  @Output() processStatusChange: EventEmitter<any> = new EventEmitter()
  priorities: any[] = [
    { id: 0, name: 'priority.lowest' },
    { id: 1, name: 'priority.low' },
    { id: 10, name: 'priority.normal' },
    { id: 20, name: 'priority.high' },
    { id: 30, name: 'priority.highest' },
  ]

  public selectedDateExpedition(value: '') {
    this.order.dateExpedition = value
    this.orderChange.emit(this.order)
  }

  removeStatusFromError(event) {
    this.processStatusChange.emit(event)
  }

  get canCreateOrEditDateExpedition(): boolean {
    return !!(
      this.order.processStatus?.id === 'recieved' ||
      this.order.processStatus?.id === 'received' ||
      this.order.processStatus?.id === 'packing' ||
      this.order.processStatus?.id === 'picking'
    )
  }
}
